module.exports = __webpack_public_path__ + "img/504.813feba6.png";